import {
  addDays, differenceInCalendarDays, endOfMonth, format, getISOWeek,
  parseISO, startOfISOWeek, startOfMonth, subMonths,
} from 'date-fns';

export const PAGE_SIZE = 20;
const iso = (d) => format(d, 'yyyy-MM-dd');

const kcFmt = new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 });
export const fmtKc = (v) => kcFmt.format(v || 0);
export const fmtCz = (s) => (s ? format(parseISO(s), 'dd.MM.yyyy') : '—');
export const fmtShort = (s) => format(parseISO(s), 'dd.MM.');
export const pctChange = (cur, prev) => (prev ? ((cur - prev) / Math.abs(prev)) * 100 : null);

export const PRESETS = [
  { id: 'this_week', label: 'Tento týden' },
  { id: 'last_week', label: 'Minulý týden' },
  { id: 'this_month', label: 'Tento měsíc' },
  { id: 'last_month', label: 'Minulý měsíc' },
  { id: 'custom', label: 'Vlastní' },
];

// Returns current range + previous range of equal length
export function computeRange(preset, custom) {
  const today = new Date();
  let from; let to; let prevFrom; let prevTo;
  if (preset === 'this_week') {
    from = startOfISOWeek(today); to = addDays(from, 6);
    prevFrom = addDays(from, -7); prevTo = addDays(to, -7);
  } else if (preset === 'last_week') {
    from = addDays(startOfISOWeek(today), -7); to = addDays(from, 6);
    prevFrom = addDays(from, -7); prevTo = addDays(to, -7);
  } else if (preset === 'this_month') {
    from = startOfMonth(today); to = today;
    prevFrom = subMonths(from, 1); prevTo = subMonths(to, 1);
  } else if (preset === 'last_month') {
    from = startOfMonth(subMonths(today, 1)); to = endOfMonth(from);
    prevFrom = subMonths(from, 1); prevTo = endOfMonth(prevFrom);
  } else {
    from = parseISO(custom.from); to = parseISO(custom.to);
    const len = differenceInCalendarDays(to, from) + 1;
    prevFrom = addDays(from, -len); prevTo = addDays(to, -len);
  }
  return { from: iso(from), to: iso(to), prevFrom: iso(prevFrom), prevTo: iso(prevTo) };
}

export function daysBetween(from, to) {
  const out = [];
  for (let d = parseISO(from); iso(d) <= to; d = addDays(d, 1)) out.push(iso(d));
  return out;
}

const inRange = (d, from, to) => d && d >= from && d <= to;

export function summarize(moves, nes, from, to) {
  const m = moves.filter((x) => inRange(x.date, from, to));
  const sum = (arr) => arr.reduce((a, x) => a + x.amount, 0);
  return {
    b290: sum(m.filter((x) => x.book === '290')),
    b291: sum(m.filter((x) => x.book === '291')),
    moves: sum(m),
    docs: m.length,
    losses: nes.filter((x) => inRange(x.batch_date, from, to)).reduce((a, x) => a + x.value, 0),
  };
}

const WD = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];

export function byDay(moves, nes, from, to) {
  return daysBetween(from, to).map((d) => ({ date: d, label: `${WD[parseISO(d).getDay()]} ${fmtShort(d)}`, ...summarize(moves, nes, d, d) }));
}

export function byWeek(moves, nes, from, to) {
  const weeks = [];
  let start = startOfISOWeek(parseISO(from));
  while (iso(start) <= to) {
    const wFrom = iso(start) < from ? from : iso(start);
    const wEnd = iso(addDays(start, 6));
    const wTo = wEnd > to ? to : wEnd;
    weeks.push({ key: iso(start), label: `T${getISOWeek(start)} (${fmtShort(wFrom)}–${fmtShort(wTo)})`, from: wFrom, to: wTo, ...summarize(moves, nes, wFrom, wTo) });
    start = addDays(start, 7);
  }
  return weeks.map((w, i) => ({ ...w, delta: i > 0 ? pctChange(w.moves, weeks[i - 1].moves) : null }));
}
